import styled from 'styled-components'
import Lottie from 'lottie-react'
import LottieData from './lottie/lottie-loading.json'
import { IonText } from '@ionic/react'
import { observer } from 'mobx-react'

type Props = {
  message?: string
}

export const DataLoadingModal: React.FC<Props> = observer(({ message }) => {
  return (
    <SpinnerContainer>
      <Lottie animationData={LottieData} />
      {message != null && (
        <IonText>
          <b>{message}</b>
        </IonText>
      )}
    </SpinnerContainer>
  )
})

const SpinnerContainer = styled.div`
  width: 100%;
  height: 80%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  ion-text {
    font-size: 16px;
    font-weight: 700;
    margin: 0 auto;
  }
`
